import styled, { css } from 'styled-components';

import { Text, Box, Chips } from '@gympass/yoga';

import FilterInput from 'components/FilterInput';

import * as endUserStyles from '../EndUser/styles';

export const Container = styled.main`
  background-color: ${({ theme }) => theme.yoga.colors.backgroundLight};
  min-height: 100vh;
  height: 100%;
  margin: ${({ theme }) => theme.yoga.spacing.zero} auto;
  padding: ${({ theme }) => theme.yoga.spacing.large}px;
`;

export const HeaderInfoContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
  padding: ${({ theme }) => theme.yoga.spacing.large}px
    ${({ theme }) => theme.yoga.spacing.zero};
`;

export const HeaderLabel = styled(Text.H4)`
  font-weight: ${({ theme }) => theme.yoga.fontWeights.light};
`;

export const Divisor = styled(endUserStyles.Divisor)`
  margin: ${({ theme }) => theme.yoga.spacing.zero};
`;

export const FiltersContainer = styled(Box).attrs({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
})`
  margin-top: ${({ theme }) => theme.yoga.spacing.small}px;
`;

export const SearchInputContainer = styled.div`
  width: 224px;
`;

export const FiltersWrapper = styled(Box).attrs({
  display: 'flex',
  alignItems: 'center',
})``;

export const PatientNameFilter = styled(FilterInput)`
  max-width: ${({ theme }) => theme.yoga.sizes.patientNameFilterMaxWidth}px;
`;

export const PatientsTableContainer = styled(Box).attrs({})`
  background: ${({ theme }) => theme.yoga.colors.white};
  margin: ${({ theme }) => theme.yoga.spacing.medium}px auto;
  padding: ${({ theme }) => theme.yoga.spacing.large}px
    ${({ theme }) => theme.yoga.spacing.medium}px;
  padding-top: ${({ theme }) => theme.yoga.spacing.xsmall}px;
  border-radius: ${({ theme }) => theme.yoga.radii.small}px;
  box-shadow: ${({ theme }) => theme.yoga.elevations.medium};
`;

export const PaginatorWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin-top: ${({ theme }) => theme.yoga.spacing.xxsmall}px;
`;

export const StyledChips = styled(Chips)`
  outline: 0;

  ${({ theme, selected }) =>
    selected
      ? css`
          background-color: ${theme.yoga.colors.primary};

          span {
            color: ${theme.yoga.colors.white} !important;
          }

          svg {
            fill: ${theme.yoga.colors.white};
          }
        `
      : css`
          &:hover:enabled {
            border-color: ${theme.yoga.colors.tableBorder};
          }

          svg {
            fill: ${theme.yoga.colors.stamina};
          }
        `};
`;
